import { Navigate } from "react-router-dom";

import { useAppContext } from "../components/contexts/appContext";
import PrivateLayout from "../components/layouts/privateLayout";

interface PrivateRouteProps {
	component: React.FC;
	hideLayout?: boolean;
}

export const PrivateRoute = ({ component: Component, hideLayout }: PrivateRouteProps) => {
	const { isUserLoggedIn, setIsUserLoggedIn } = useAppContext();

	const handleLogout = () => {
		localStorage.clear();
		setIsUserLoggedIn(false);
	};

	if (isUserLoggedIn) {
		return hideLayout ? (
			<Component />
		) : (
			<PrivateLayout handleLogout={handleLogout}>
				<Component />
			</PrivateLayout>
		);
	}
	return <Navigate to="/" replace />;
};
